import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import OSHighwaysService from "../services/OSHighwaysService";

const useOSHighwaysService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new OSHighwaysService(client);
  }, [client]);

  return service;
};

export default useOSHighwaysService;
